import { Button,Input } from 'components/atoms/index';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    type ChartOptions,
    type ChartData,
  } from 'chart.js';
  import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Bar } from 'react-chartjs-2';
import TaskCard from '@/components/organisms/Card/Exam/TaskCard';




// Chart.js 등록
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const data: ChartData<'bar'> = {
    labels: ['객관식', '주관식', '프리라이팅'],
    datasets: [
      {
        label: '점수',
        data: [85, 78, 100],
        backgroundColor: '#6366f1',
        borderRadius: { topLeft: 8, topRight: 8 },
        barThickness: 40,
      },
    ],
    
  };
  
  const options: ChartOptions<'bar'> = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
        padding: {
            top: 20,
        },
    },
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
      // ✅ datalabels 옵션은 plugins.datalabels 아래에
      datalabels: {
        anchor: 'end',
        align: 'top',
        offset: 2,
        font: { weight: 'normal' },
        color: '#6b7280',
        formatter: (v) => `${v}%`,
        display: true,
      },
    },
    scales: {
        y: {
          beginAtZero: true,
          max: 100, // 최대값을 120으로 설정 (막대 높이 제한)
          display: true,
          grid: {
            display: true,
            color: '#e5e7eb',
          },
          ticks: {
            color: '#6b7280',
            font: {
              size: 12,
            },
            stepSize: 50,
            callback: function(tickValue: string | number) {
              const value = Number(tickValue);
              return value === 0 || value === 50 || value === 100 ? value : '';
            },
          },
        },
        x: {
          display: true,
          grid: {
            display: false,
          },
          ticks: {
            color: '#6b7280',
            font: {
              size: 12,
            },
          },
        },
      },
  };

// 시험 결과 페이지
export default function StudentResult() {

  return (
    <main className='flex flex-1 justify-center w-full bg-white lg:my-10 card md:bg-transparent'>
        <div className='flex-1 px-5 pb-8'>
            <div className='pt-8 pb-5'>
                <div className='flex justify-between items-center'>
                    <h1 className='heading1'>김알파 시험 성적표</h1>
                    <Button size='small' intent='secondary' className='w-16 pointer-events-none'>채점중</Button>  
                </div>
                <p className='pt-1 text-sm text-gray-400'>2012.12.12 응시완료</p>
            </div>

            <div className='flex flex-col gap-5'>
                <section className='overflow-hidden rounded-2xl'>
                    <div className='flex justify-between items-center px-5 py-3 text-lg font-bold back_gra_ravendar'>
                        <h2>중간고사-1-1</h2>
                        <p>(90/100)</p>
                    </div>

                    <div className='p-5 bg-gray-50'>
                        <p>홍길동 학생의 객관식 항목 점수는 전체적으로 우수한  편입니다만, 일부 문제에서 자주 틀리는 유형이 발견되었습니다.
                        특히 7번, 9번, 11번 문제는 동일한 유형의 문법에 대해 적절한 단어를 고르는 유형이나, 이러한 문법 유형에 취약한 것으로 확인됩니다.</p>
                    </div>
                </section>

                <section className='overflow-hidden rounded-2xl'>
                    <div className='flex justify-between items-center px-5 py-3 text-lg font-bold back_gra_ravendar'>
                        <h2>주관식 시험</h2>
                        <p>(90/100)</p>
                    </div>

                    <div className='p-5 bg-gray-50'>
                        <p>주어진 문장에 대비 작성능력이 우수한 편입니다. 다만, 답안 작성시 띄어쓰기와 오타 등을 더욱 주의할 수 있도록 하면 좋겠습니다.</p>
                    </div>
                </section>

                <section className='overflow-hidden rounded-2xl'>
                    <div className='flex justify-between items-center px-5 py-3 text-lg font-bold back_gra_ravendar'>
                        <h2>프리라이팅 시험</h2>
                        <p>(90/100)</p>
                    </div>

                    <div className='p-5 bg-gray-50'>
                        <p>구사하는 문장 대부분에 큰 오류는 없으나, 일부 고난도 문법에 취약한 부분이 확인됩니다.</p>
                    </div>
                </section>
            </div>

            {/* 시험 성적 요약 */}
            <section className=''>
                    <h2 className='pt-8 pb-5 heading1'>시험 성적 요약</h2>
                    <div className='lg:grid lg:grid-cols-2 lg:gap-10'>
                        <div>
                            <div className='flex flex-col gap-2'>
                                <span className='text-sm font-bold text-gray-500'>시험 점수</span>
                                <div className='overflow-hidden rounded-2xl border border-gray-200'>
                                    {/* 시험 점수 테이블 */}
                                    <table className='w-full text-sm font-bold text-center'>
                                        <colgroup className=''>
                                            <col className='text-center' />
                                            <col className='w-[calc((100%/3)-50px)]' />
                                            <col className='w-[calc((100%/3)-50px)]' />
                                            <col className='w-[calc((100%/3)-50px)]' />
                                        </colgroup>
                                        <thead className='text-gray-500 bg-gray-50'>
                                            <tr className='*:py-1.5'>
                                                <th></th>
                                                <th className=''>객관식</th>
                                                <th>주관식</th>
                                                <th>프리라이팅</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className='*:py-1'>
                                                <td>총점</td>
                                                <td>70</td>
                                                <td>20</td>
                                                <td>10</td>
                                            </tr>
                                            <tr className='*:py-1'>
                                                <td>득점</td>
                                                <td className='text-indigo-500'>50</td>
                                                <td className='text-indigo-500'>20</td>
                                                <td className='text-indigo-500'>10</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>
                            </div>

                            {/* 감점 된 문제 */}
                            <div className='flex flex-col gap-2 mt-4'>
                                <span className='text-sm font-bold text-gray-500'>감점된 문제</span>
                                <div className='overflow-hidden p-4 bg-gray-50 rounded-2xl border border-gray-200'>
                                    <ul className='flex flex-col gap-2'>
                                        {Array.from({ length: 5 }, (_, index) => (
                                            <li key={index + 1} className='flex justify-between items-center p-2 bg-white rounded-lg'>
                                                <p className='underline'>{index + 1}번</p>
                                                <Button size='small' className=''>선생님 코멘트 보기</Button>  
                                            </li>
                                        ))}       
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div>
                            <span className='text-sm font-bold text-gray-500'>시험 요약</span>
                            <div className='p-4 bg-gray-50 rounded-2xl border border-gray-200'>
                                <div className='pt-8 pb-4 h-100'>
                                <Bar data={data} options={options} plugins={[ChartDataLabels]} className='overflow-visible' />
                                </div>
                            </div>
                        </div>
                    </div>
            </section>
            <section className=''>
                <h2 className='pt-8 pb-3 heading1'>오답 노트</h2>
                <div className='flex flex-col gap-2 lg:grid lg:grid-cols-2 lg:gap-0 lg:*:odd:border-r lg:*:odd:border-r-gray-200 lg:*:odd:pr-5 lg:*:even:pl-5 lg:*:py-5'>
                    <TaskCard 
                        className=''
                        questionType='multiple' 
                        question='1. 다음 그림에 맞는 단어를 선택해주세요' 
                        options={[
                            {id: 1, word: 'apple'}, 
                            {id: 2, word: 'banana'}, 
                            {id: 3, word: 'orange'}, 
                            {id: 4, word: 'grape'}, 
                            {id: 5, word: 'strawberry'}
                        ]} 
                        showFeedback={true}
                    />

                    <TaskCard 
                        className=''
                        questionType='short' 
                        question='1. 다음 그림에 맞는 단어를 선택해주세요' 
                        options={[
                            {id: 1, word: 'apple'}, 
                            {id: 2, word: 'banana'}, 
                            {id: 3, word: 'orange'}, 
                            {id: 4, word: 'grape'}, 
                            {id: 5, word: 'strawberry'}
                        ]} 
                        showFeedback={true}
                    />

                    <TaskCard 
                        className='lg:py-5'
                        questionType='essay' 
                        question='1. 다음 그림에 맞는 단어를 선택해주세요' 
                        options={[
                            {id: 1, word: 'apple'}, 
                            {id: 2, word: 'banana'}, 
                            {id: 3, word: 'orange'}, 
                            {id: 4, word: 'grape'}, 
                            {id: 5, word: 'strawberry'}
                        ]} 
                        showFeedback={true}
                    />
                </div>
            </section>

            <section>
                <Button size='large' className='mt-10 w-full'>시험 응시내역 확인</Button>
            </section>
        </div>
    </main>
  )
}